import { ValueSetReference } from 'src/app/models/value-set-reference.model';

export class ValueSetsDialogModel {
  constructor(
    public code: string,
    public display: string,
    public valueSets: ValueSetReference[],
    public pinnedValueSets: ValueSetReference[]) { }
}
